import { timelineStages } from '@/mocks/campusData';

const stateMeta: Record<string, { dot: string; text: string; label: string }> = {
  rumor: { dot: 'bg-red-500 ring-red-200', text: 'text-red-700', label: '谣言酝酿' },
  heat: { dot: 'bg-orange-400 ring-orange-200', text: 'text-orange-600', label: '热度扩散' },
  verify: { dot: 'bg-teal-600 ring-teal-200', text: 'text-teal-700', label: '官方辟谣' },
  reverse: { dot: 'bg-amber-500 ring-amber-200', text: 'text-amber-600', label: '剧情反转' },
  settle: { dot: 'bg-emerald-600 ring-emerald-200', text: 'text-emerald-700', label: '真相复盘' },
};

export default function Timeline() {
  return (
    <section id="timeline" className="border-y border-stone-200 bg-white/60">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-4">
            <p className="mb-2 flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-red-600">
              <span className="inline-block h-px w-6 bg-red-500" />
              反转现场
            </p>
            <h2 className="font-editorial text-2xl font-black leading-snug text-stone-900 md:text-3xl">
              复盘典型案例：
              <br />
              “奖学金内定名单”事件
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-stone-600">
              从一张截图到尘埃落定，这场风波在 4 天内走完了“谣言 → 扩散 → 辟谣 → 反转 → 复盘”的完整链路。
              看时间线，你就知道吃瓜为什么要吃到结局。
            </p>

            <div className="mt-6 rounded-xl border border-stone-200 bg-[#faf4ea] p-5">
              <p className="text-sm font-bold text-stone-900">案例结论 · 一段话复盘</p>
              <p className="mt-2 text-sm leading-relaxed text-stone-600">
                所谓“内定”，本质是对未定稿文件截图的断章取义与二次传播。当官方公示与原始评审记录开放核对后，核心质疑全部站不住脚，
                <strong className="text-red-700">打脸的不是当事人，而是急着下结论的人</strong>。
              </p>
            </div>
          </div>

          <div className="md:col-span-8">
            <ol className="relative space-y-6 border-l-2 border-dashed border-stone-300 pl-6">
              {timelineStages.map((s) => {
                const meta = stateMeta[s.state];
                return (
                  <li key={s.day} className="relative">
                    <span className={`absolute -left-[31px] top-1 flex h-4 w-4 items-center justify-center rounded-full ring-4 ${meta.dot}`} />
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="text-xs font-semibold uppercase tracking-wide text-stone-400">{s.day}</span>
                      <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${meta.text} bg-stone-100`}>
                        {meta.label}
                      </span>
                    </div>
                    <h3 className="mt-1.5 text-base font-bold text-stone-900">{s.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-stone-600">{s.detail}</p>
                  </li>
                );
              })}
            </ol>

            <div className="mt-7 flex flex-wrap items-center gap-2 rounded-lg bg-stone-100 px-4 py-3 text-xs text-stone-600">
              <i className="ri-lightbulb-flash-line text-base text-amber-500" />
              吃瓜小贴士：一条信息被转发越多、语气越笃定，越要先等原始出处。反转，往往出现在大家都不看细节的时候。
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}